import React, { Component } from 'react'
import { Link } from 'react-router-dom'

class MenuListComponent extends Component {
  setActiveMenu = menuID => {
    const { OnMenuLinkClick } = this.props
    OnMenuLinkClick(menuID)
  }

  render() {
    const { menuId, iconClass, menuLink, menuName } = this.props
    return (
      <>
        <li className="menu">
          <Link
            to={menuLink}
            className="dropdown-toggle"
            id={menuId}
            onClick={() => this.setActiveMenu(menuId)}
          >
            <div className="">
              <i className={iconClass} />
              <span> {menuName} </span>
            </div>
          </Link>
        </li>
      </>
    )
  }
}

export default MenuListComponent
